<template src="./driverprofilepicture.html"></template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
  /* props: ["Driver"], */
  props: {
    DriverFName: String,
    DriverLName: String,
    ColorCode: String,
  },
  filters: {},
  data() {
    return {
      driverBgColor: "576E7A",
      firstLetter: "",
      secondLetter: "",
      driverImage: "",
    };
  },
  mounted() {
    this.driverBgColor =
    this.ColorCode != "" ? "#" + this.ColorCode : "#576E7A";
    this.firstLetter = this.DriverFName ? this.DriverFName.charAt(0) : '';
    this.secondLetter = this.DriverLName ? this.DriverLName.charAt(0) : '';
  },
};
</script>

<style scoped>
.randon-picture {
  margin: 0 auto;
  font-size: 85px;
  padding-top: 30px;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
}
.randon-picture-profile {
  margin: 0 auto;
  font-size: 85px;
  padding-top: 19px;
  color: #fff;
  text-align: center;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.randon-picture-quick-view {
  margin: 0 auto;
  font-size: 24px;
  padding-top: 8px;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
}
.randon-picture-action-needed {
  margin: 0 auto;
  font-size: 11px;
  padding-top: 8px;
  color: #fff;
  text-align: center;
  height: 30px;
  width: 30px;
  text-transform: uppercase;
}
.dashboard-quick-view {
  width: 50px;
  color: #fff;
  font-size: 22px;
  padding: 6px 4px;
  height: 50px;
  text-align: center;
}
</style>
